import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BulkPrintService {

  premiumAccess$ = new BehaviorSubject<any>(false);


  constructor(
    private http: HttpClient
  ) { }

  setPremiumAccess(data: any) {
    this.premiumAccess$.next(data);
  }

  getPremiumAccess(): Observable<any> {
    return this.premiumAccess$.asObservable();
  }

  fetchPremiumAccess() {
    return this.http.get(`${environment.apiUrl}/mgmt/user/company/premiumAccess`).pipe(map((response) => {
      return response;
    }));
  }

  getBulkPrintHistoryData(page, size, id) {
    return this.http.get(`${environment.apiUrl}/onyx/einvoice/bulkprint/filter/history?page=${page}&size=${size}&companyUniqueId=${id}`).pipe(map((response) => {
      return response;
    }));
  }

  getStatusForDownload(id, esignFlag) {
    return this.http.get(`${environment.apiUrl}/onyx/einvoice/bulkprint/status?id=${id}&esignFlag=${esignFlag}`).pipe(map((response) => {
      return response;
    }));
  }

  getBulkPrintCount(model:any){
    return this.http.post(`${environment.apiUrl}/onyx/download/pan/bulk/einvoices/count`, model).pipe(map((response) => {
      return response;
    }));
  }

  bulkPrintPdf(model, esignVal, corpSigner){
    let url = `${environment.apiUrl}/onyx/download/pan/bulk/einvoices?esignReq=${esignVal}`
    if(corpSigner){
      url = `${url}&esignType=CORP_SIGN`
    }
    return this.http.post(url, model).pipe(map((response) => {
      return response;
    }));
  }

  setOtherSetting(model){
    return this.http.post(`${environment.apiUrl}/mgmt/company/business`, model).pipe(map((response) => {
      return response;
    }));
  }

  fetchPdfname(id){
    return this.http.get(`${environment.apiUrl}/mgmt/user/company/fileNameByUserGstin?gstnNo=${id}`).pipe(map((response) => {
      return response;
    }));
  }

}
